import userReducer from './user/reducer'
import companyReducer from './company/reducer';
import { combineReducers } from 'redux'

const allReducers = combineReducers({
    user: userReducer,
    company: companyReducer,
});

export default allReducers;